
import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appCutText]'
})
export class CutTextDirective implements AfterViewInit {
  @Input() appCutText: number = 100;

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    
    const text = this.elementRef.nativeElement.innerText;
    if (text.length > this.appCutText) {
      const truncatedText = text.substring(0, this.appCutText) + '...';
      this.elementRef.nativeElement.innerText = truncatedText;
    }
  }
}